<h1 class="display">Reset password</h1>
<section class="ctx-card">
  <section class="ctx-card__content">
    <form
      class="flex flex-col gap-4 py-2"
      [formGroup]="formGroup"
      (ngSubmit)="submit()"
    >
      <section class="flex flex-col gap-4">
        <!-- Alert -->
        @if (showApiMessage) {
        <ctx-alert [alertLevel]="apiMessage.alertLevel">{{
          apiMessage.text
        }}</ctx-alert>
        }
        <!-- Email -->
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" required />
          <mat-hint
            >Enter the email address you registered with and we'll send you a
            link to reset your password.</mat-hint
          >
          <mat-error>{{ getControlError(formGroup, 'email') }}</mat-error>
        </mat-form-field>
      </section>
      <button
        ctx-button--primary
        [disabled]="formStates.disabled"
        [loading]="formStates.submit"
        type="submit"
      >
        Send Reset Link
      </button>
      <a class="mt-3 self-start" routerLink="/auth/login">Back to Login</a>
    </form>
  </section>
</section>
